export default __webpack_public_path__ + "static/media/Background_00164.6b063da1.png";